import styles from './YellowTabs.module.scss';

const YellowTabs = ({ tabs, activeTab, setActiveTab }) => (
  <div className={styles.container}>
    {tabs.map((tab) => (
      <div
        key={tab}
        className={`${styles.tab} ${activeTab === tab ? styles.active : ''}`}
        onClick={() => setActiveTab(tab)}
      >
        {tab}
      </div>
    ))}
  </div>
);

export default YellowTabs;